import type { FormalityRequestType } from "@/types/entities/formality-request";

/** Every shape the group id has historically been stored under. */
type GroupIdSource = {
  groups?: Array<{ id: string }>;
  approval_group_id?: string;
  group_id?: string;
};

/**
 * Resolves which approval group a correction belongs to. The group is not
 * stored consistently, so this walks the known locations in priority order:
 * the group selected in the URL first, then the revision, then the form
 * assignment, and finally the formality request.
 */
export function resolveGroupId(
  activeRevision: unknown,
  formAssignment: unknown,
  formalityRequest: FormalityRequestType | undefined,
  selectedGroupId: string | null,
) {
  const revision = activeRevision as GroupIdSource;
  const assignment = formAssignment as GroupIdSource;
  const revisionGroups = revision.groups;

  return (
    selectedGroupId ||
    (revisionGroups && revisionGroups.length > 0
      ? revisionGroups.at(-1)?.id
      : null) ||
    revision.approval_group_id ||
    revision.group_id ||
    assignment.approval_group_id ||
    assignment.group_id ||
    formalityRequest?.groups?.[formalityRequest.groups.length - 1]?.id ||
    formalityRequest?.group_id
  );
}
